module.exports = __webpack_public_path__ + "img/build3.b1eb2905.png";